export enum OrderPaymentMethods {
  PAY_PAL = 'payPal',
  CASH = 'cash',
  AT_DELIVERY = 'at_delivery'
}
